import {useEffect, useState} from "react";
import {useMutation} from "@apollo/client";
import { ExchangeTokenDocument } from "generated/graphql";
import {setToken, useOrcIdLogin, userVar} from "utilities/auth";
import {SetUserDetailsDialog} from "routes/Dialogs/SetUserDetailsDialog";

export function Callback() {
  const [exchangeToken] = useMutation(ExchangeTokenDocument);
  const {backToLast} = useOrcIdLogin();
  const [userDialogOpen, setUserDialogOpen] = useState(false);

  const idToken = window.location.hash
    .split('&')
    .map(t => t.split('='))
    .filter(p => p[0] === "id_token")[0]?.[1];

  useEffect(() => {
    if (!idToken) return;
    exchangeToken({ variables: { input: { orcIdToken: idToken }} })
      .then(r => {
        if (!r.data?.exchangeToken) return;
        setToken(r.data?.exchangeToken.token);
        const user = userVar();
        if (user?.lastName) {
          backToLast();
        } else {
          setUserDialogOpen(true);
        }
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idToken]);

  return <>
    { idToken && <i>Processing login...</i> }
    { !idToken && <>No token found, try again</> }
    <SetUserDetailsDialog open={userDialogOpen} onClose={backToLast} />
  </>;
}
